// Build information
declare const __BUILD_TIME__: string;
declare const __GIT_COMMIT__: string;
declare const __BUILD_ENV__: string;

import { debug } from "@/lib/debug";

// Always show build info in console (useful for support and debugging)
debug.banner(
  '🔨 Nordex Build Info',
  'background: #4CAF50; color: white; padding: 4px 8px; border-radius: 3px; font-weight: bold',
  `📅 Build Time: ${__BUILD_TIME__}`,
  `🔖 Git Commit: ${__GIT_COMMIT__}`,
  `🌍 Environment: ${__BUILD_ENV__}`,
);

// Buffer polyfill for Solana libraries that use Node.js Buffer
import { Buffer } from "buffer";
window.Buffer = Buffer;

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { App } from "@/app.tsx";
import mixpanel from "mixpanel-browser";
import { ErrorBoundary } from "@/components/error-boundary";

// Initialize Mixpanel analytics
const mixpanelToken = import.meta.env.VITE_PUBLIC_MIXPANEL_TOKEN;
const mixpanelApiHost = import.meta.env.VITE_PUBLIC_MIXPANEL_API_HOST;

if (mixpanelToken) {
  mixpanel.init(mixpanelToken, {
    api_host: mixpanelApiHost || 'https://api-eu.mixpanel.com',
    autocapture: true,
    record_sessions_percent: 100,
    record_max_ms: 5 * 60 * 1000, // Cap replay recordings at 5 minutes (login/signup/onboarding flows)
    record_mask_text_selector: '.sensitive-data',
    persistence: 'localStorage',
  });
} else {
  debug.warn("Mixpanel", "Analytics disabled: missing VITE_PUBLIC_MIXPANEL_TOKEN env var");
}

const RootApp = (
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);

createRoot(document.getElementById("root")!).render(RootApp);
